import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Container,
  CardContent,
  Divider,
  Card,
  Tooltip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Collapse,
  TextField,
} from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import Typography from "@mui/material/Typography";
import Popover from "@mui/material/Popover";
import SearchField from "react-search-field";
import { Tab, Tabs } from "@mui/material";
import Paper from "@mui/material/Paper";
import CardHeader1 from "./LabHeader";
import Link from "@mui/material/Link";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@mui/material/IconButton";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import StartLab from "../Actions/Startlab";
import StopLab from "../Actions/Stoplab";
import IndividualStartLab from "../Actions/IndividualStartlab";
import IndividualStopLab from "../Actions/IndividualStoplab";
import StopTwoToneIcon from "@mui/icons-material/StopTwoTone";
import PlayArrowTwoToneIcon from "@mui/icons-material/PlayArrowTwoTone";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ActiveLog from "src/pages/LabManager/ActiveLog";
import moment from "moment";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Refresh from "../Actions/Reload";
import Log from "./Logs/WiseLog";
import TraineeGuacConnect from "./TraineeGuacConnect";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import WarningAlert from "../Alert/WarningAlert";
import NotToDo from "../Actions/NotToDo";

const dialogWidth = '1100px';
const dialogHeight = '97vh';

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: dialogWidth,
    height: dialogHeight, // Use full viewport height
    maxWidth: 'none',
    margin: 0,
    padding: theme.spacing(2),
    overflow: 'hidden', // Ensure no overflow on the dialog itself
    display: 'flex', // Flexbox to manage layout
    flexDirection: 'column',
  },
  '& .MuiDialogContent-root': {
    padding: 0,
    flexGrow: 1, // Take remaining space
    overflow: 'auto', // Enable scrolling on the content area
  },
  '& .MuiDialogActions-root': {
    justifyContent: 'flex-end',
  },
}));

const ensureAbsoluteUrl = (url) => {
  if (!url) return '#'; // Fallback in case URL is null or undefined
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`;
  }
  return url;
};


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const Detail = () => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [validerroropen, setValidErrorOpen] = useState(false); // <-- modal state

  const handleExpandRow = (rowName) => {
    if (rowName === expandedRow) {
      setExpandedRow(null);
    } else {
      setExpandedRow(rowName);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [value, setValue] = React.useState("");
  const guacamole_url = process.env.REACT_APP_GUACAMOLE_URL;

  function DateTime1(startDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const startDate1 = new Date(startDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const startDate2 = startDate1.split(",");
    const startDatef = startDate2[0].replace("/", "-");
    const startDate3 = startDatef.replace("/", "-");

    return startDate3;
  }

  function DateTime21(endDate) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate).toLocaleString("en-GB", {
      timeZone: `${timezone}`,
    });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime2(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endDate1 = new Date(endDate + "T" + endTime + ":00.000Z").toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endDate2 = endDate1.split(",");
    const endDatef = endDate2[0].replace("/", "-");
    const endDate3 = endDatef.replace("/", "-");
    return endDate3;
  }

  function DateTime3(startDate, startTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const startTime1 = new Date(
      startDate + "T" + startTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const startTime2 = startTime1.split(",");
    const startTime3 = startTime2[1].substring(0, 6);
    return startTime3;
  }

  function DateTime4(endDate, endTime) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime1 = new Date(
      endDate + "T" + endTime + ":00.000Z"
    ).toLocaleString("en-GB", { timeZone: `${timezone}` });
    const endTime2 = endTime1.split(",");
    const endTime3 = endTime2[1].substring(0, 6);
    return endTime3;
  }

  const handleChange = (event) => {
    setValue(parseInt(event.target.value));
  };

  const [instancelist, setinstancelist] = useState([]);
  const [feedbackResponse, setFeedbackResponse] = useState([]);
  const [openAssessmentDialog, setOpenAssessmentDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  // const [depends_On, setDependsOn] = useState('');
  // const [manage_Labs, setManageLabs] = useState('');
  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    const instanceLabType = "wise"
    fetch(`${process.env.REACT_APP_API_URL}/api/traineewisedetails/${InstanceID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setinstancelist(data);
          // const depends_on = data.map(item => item.depends_on)
          // setDependsOn(depends_on[0]);
          // const manage_labs = data.map(item => item.manage_labs)
          // setManageLabs(manage_labs[0]);

          const trainee_id = data.map(item => item.trainee_id)
          const end_date = data.map(item => item.end_date)
          const stop_time = data.map(item => item.stop_time)
          // setPopupStatus(data[0]?.popup_status || "");
          if (data[0]?.popup_status === "no" || data[0]?.popup_status === "") {
            setValidErrorOpen(true);
          }

          if (trainee_id !== "" && end_date !== "" && stop_time !== "") {
            fetch(`${process.env.REACT_APP_API_URL}/api/traineefeedbackdetails/`, {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
              .then((resp) => resp.json())
              .then((data) => {
                if (data.detail) {
                } else {
                  setFeedbackResponse(data);
                  if (data === "No Feedback found") {
                    setOpenDialog(true);
                  } else {
                    setOpenDialog(false);
                    // console.log("steep -2  --> ");
                    if (!feedbackResponse || feedbackResponse.length === 0) {
                      fetch(`${process.env.REACT_APP_API_URL}/api/verifyquizinformation/`, {
                        method: 'GET',
                        headers: {
                          'Content-Type': 'application/json',
                          Authorization: 'Bearer ' + localStorage.getItem('token'),
                        },
                      })
                        .then((resp) => resp.json())
                        .then((data) => {
                          if (data.detail) {
                            // Handle if detail is present
                          } else {
                            if (data === "No Assessment found") {
                              setOpenAssessmentDialog(true);
                            } else {
                              setOpenAssessmentDialog(false);
                            }
                          }
                        })
                        .catch((error) => {
                          console.error(error);
                        });
                    }
                  }
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }

        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function timeDiff(endDate, endTime, startDate, startTime, dependsOn, manageLabs) {
    const nowTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const endTime3 = new Date(`${endDate}T${endTime}:00.000Z`).toLocaleTimeString("en-GB", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const startTime3 = new Date(`${startDate}T${startTime}:00.000Z`).toLocaleTimeString("en-GB", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    const endTimeMoment = moment(endTime3, 'HH:mm');
    const currentTimeMoment = moment(nowTime, 'HH:mm');

    const diffInMinutes = endTimeMoment.diff(currentTimeMoment, 'minutes');
    let disable = true;

    const labEndDate = moment(endDate).format('DD-MM-YYYY');
    var currentDate = new Date().toISOString().substring(0, 10);

    // console.log("step-1")
    // console.log("Total-Difference", diffInMinutes)
    // console.log("currentDate", DateTime2(currentDate))
    // console.log("labEndDate", labEndDate)
    // console.log("current_time", nowTime)
    // console.log("end_time", endTimeMoment)
    if (dependsOn === "immediate" || dependsOn === "always") {
      if (DateTime21(currentDate) == labEndDate) {
        if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
          disable = true;
        }
        else if (diffInMinutes <= 0) {
          disable = true;
        }
        else {
          disable = false;
        }
      }
      else {
        if (new Date(currentDate) <= new Date(endDate)) {
          disable = false;
        }
        else {
          disable = true;
        }
      }
    }
    else if (dependsOn === "during_training") {
      if (diffInMinutes > 0 && diffInMinutes <= `${process.env.REACT_APP_DIFFENDTIME}`) {
        disable = true;
        return disable;
      } else if (currentTimeMoment.isSameOrAfter(moment(startTime3, 'HH:mm')) && currentTimeMoment.isSameOrBefore(moment(endTime3, 'HH:mm'))) {
        disable = false;
        // return disable;       
      } else if (dependsOn === "during_training" && manageLabs === "yes") {
        disable = false;
        return disable;
      } else if (dependsOn === "during_training" && manageLabs === "no" && currentTimeMoment.isAfter(moment(endTime3, 'HH:mm'))) {
        disable = true;
      }
    }
    return disable;
  }

  const [showInstancePassword, setShowInstancePassword] = useState(false);
  const [showAppPasswords, setShowAppPasswords] = useState(false);

  const handleInstancePasswordIconClick = () => {
    setShowInstancePassword(!showInstancePassword);
  };

  const handleAppPasswordIconClick = () => {
    setShowAppPasswords(!showAppPasswords);
  };


  const [pccreportdataset, setPccreportdataset] = useState([]);

  useEffect(() => {
    const InstanceID = localStorage.getItem("InstanceID");
    fetch(`${process.env.REACT_APP_API_URL}/api/wiselabreport/${InstanceID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        setPccreportdataset(data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl(null);
  };

  const open1 = Boolean(anchorEl);

  const id = open1 ? "simple-popover" : undefined;

  // const [selectedIndex, setSelectedIndex] = React.useState(0);
  // const handleMenuItemClick = (event, index) => {
  //   setSelectedIndex(index);
  // };

  const handleDialogClose = () => {
    setOpenDialog(false);
    window.location.href = '/app/feedback';
  };

  const handleAssessmentDialog = () => {
    setOpenAssessmentDialog(false);
    window.location.href = '/app/assessmentlist';
  };

  const [searchitems, setSearchItems] = React.useState(0);
  const [copied, setCopied] = React.useState(false);

  useEffect(() => {
    setExpandedRow("");
  }, [value])

  const [openDialog1, setOpenDialog1] = useState(false);
  const [guacData, setGuacData] = useState([]);
  const [refreshConnection, setRefreshConnection] = useState(false);

  // const handleConnectClick = (details) => {
  //   setGuacData(details);
  //   setOpenDialog(true);
  // };

  const handleCloseDialog = () => {
    setOpenDialog1(false);
  };

  const handleRefreshConnection = () => {
    setRefreshConnection(true);
  };

  // console.log("guacData", guacData);
  // console.log("instancelist", instancelist);

  // const handleConnectClick = (details) => {
  //   setGuacData(details);
  //   localStorage.setItem('guacData', JSON.stringify(details));
  //   window.open('traineeguacconnect', '_blank');
  // };

  // const handleConnectClick = (details) => {
  //   const url = new URL(window.location.href);
  //   url.pathname = "/guacconnect";
  //   url.searchParams.set("details", JSON.stringify(details));
  //   window.open(url.toString(), "_blank");
  // };

  return (
    <>
      <WarningAlert
        validerroropen={validerroropen}
        setvaliderroropen={setValidErrorOpen}
        alertLabType={"wise"}
      />
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Pending Feedback Notification!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please ensure that all feedback submissions are completed before proceeding
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <CustomDialog
        open={openDialog1}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ marginTop: "-30px", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} id="alert-dialog-title">
          Guacamole Display - Machine Name : {guacData.name}
          <div>
            <IconButton
              aria-label="refresh"
              onClick={handleRefreshConnection}
              style={{ color: 'blue' }}
            >
              <RefreshIcon />
            </IconButton>
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              style={{ color: 'red' }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent style={{ marginTop: "-20px" }}>
          <TraineeGuacConnect
            details={guacData}
            width={dialogWidth}
            height={dialogHeight}
            refreshConnection={refreshConnection}
            disableCopyPaste={instancelist.disable_copypaste_guac}
            onRefreshComplete={() => setRefreshConnection(false)}
          />
        </DialogContent>
      </CustomDialog>
      <Dialog
        open={openAssessmentDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Pending Assessment Notification!
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Please ensure that all assessment submissions are completed before proceeding.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAssessmentDialog} color="primary" autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      {instancelist.map((instancelist) => (
        <React.Fragment>
          <Helmet>
            <title>LabAsService</title>
          </Helmet>
          <Box
            sx={{
              backgroundColor: "background.default",
              minHeight: "100%",
              py: 3,
            }}
          >

            <Box sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexWrap: "wrap",
                // gap: { xs: 1, sm: 1.2 },
                pr: { xs: 1, sm: 2 },
                mt: { xs: 0.5, sm: 1 },
              }}
            >
              <NotToDo/>
              <Refresh />
              {instancelist.trainee_labstatus === "Stopped" ? (
                <StartLab traineetag={instancelist.trainee_id} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                  startTime={`${instancelist.start_time}`} depends_on={instancelist.depends_on} manage_labs={instancelist.manage_labs} startcron={instancelist.startcron_expression} startcron1={instancelist.startcron_expression2} repeat_frequency={instancelist.repeat_frequency} on_days={`${instancelist.on_days}`} labType={"wise"}/>
              ) : instancelist.trainee_labstatus === "Running" ? (
                <React.Fragment>
                  <StopLab traineetag={instancelist.trainee_id} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`}
                    startTime={`${instancelist.start_time}`} depends_on={instancelist.depends_on} manage_labs={instancelist.manage_labs} labType={"wise"}/>
                </React.Fragment>
              ) : instancelist.trainee_labstatus === "Stop Initiated" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginBottom: "5px",
                    marginTop: "-15px",
                    marginRight: "30px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<StopTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                >
                  Stop Initiated
                </Button>
              ) : instancelist.trainee_labstatus === "Start Initiated" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '150px',
                    height: '30px',
                    marginBottom: "5px",
                    marginTop: "-15px",
                    marginRight: "30px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                >
                  Start Initiated
                </Button>
              ) : instancelist.trainee_labstatus === "Stopping" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '140px',
                    height: '30px',
                    marginBottom: "5px",
                    marginTop: "-15px",
                    marginRight: "30px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<StopTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                >
                  Stopping
                </Button>
              ) : instancelist.trainee_labstatus === "Starting" ? (
                <Button
                  sx={{
                    mx: 1,
                    width: '140px',
                    height: '30px',
                    marginBottom: "5px",
                    marginTop: "-15px",
                    marginRight: "30px",
                  }}
                  style={{ whiteSpace: 'nowrap' }}
                  variant="outlined"
                  color="primary"
                  startIcon={<PlayArrowTwoToneIcon />}
                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`, `${instancelist.start_date}`,
                    `${instancelist.start_time}`, instancelist.depends_on, instancelist.manage_labs)}
                >
                  Starting
                </Button>
              ) : (
                ""
              )}
            </Box>
            <Container maxWidth={false}>
              <Box border={0} sx={{ mt: 0 }}>
                <Card>
                  <CardContent>
                    <Box
                      sx={{
                        background: 'linear-gradient(90deg, rgb(6, 57, 108), rgb(6, 57, 108))',
                        borderRadius: '8px',
                        px: 2,
                        py: 0.75, // ↓ reduced vertical padding for smaller height
                        mb: 2,
                        boxShadow: 2,
                      }}
                    >
                      <Typography
                        color="white"
                        display="inline-block"
                        gutterBottom
                        variant="h6"
                        sx={{
                          lineHeight: 1.1,
                          fontWeight: 500, // reduced from 'bold' (700) → medium weight
                        }}
                        
                      >
                        Lab Name: {instancelist.name}
                      </Typography>
                    </Box>
                    <div>
                      <TableContainer component={Paper}>
                        <Table size="small" aria-label="simple table">
                          <TableBody>
                            <TableRow key="name">
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  CodeShare : <Tooltip title="Open CodeShare" arrow>
                                    <Button
                                      size="small"
                                      sx={{
                                        height: "25px",
                                        borderRadius: '50px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        px: 2,
                                      }}
                                      variant="outlined"
                                      target="_blank"
                                      endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                      href={instancelist.codeshare}
                                    >
                                      Open
                                    </Button>
                                  </Tooltip>
                                  <CopyToClipboard
                                    text={instancelist.codeshare}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose1}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "forestgreen",
                                      }}
                                    >
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{
                                    display: "inline-block",
                                  }}
                                  gutterBottom
                                >
                                  Status : <span style={{ fontWeight: "normal" }}>{instancelist.trainee_labstatus}</span>
                                </Typography>
                              </TableCell>
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Number of Trainees : <span style={{ fontWeight: "normal" }}>{instancelist.no_of_trainee}</span>
                                </Typography>
                              </TableCell>
                              <TableCell
                                align="left"
                                component="th"
                                scope="row"
                              >
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Schedule : <span style={{ fontWeight: "normal" }}>{instancelist.depends_on}</span>
                                </Typography>
                              </TableCell>
                            </TableRow>
                            <TableRow key="name">

                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Start Date : <span style={{ fontWeight: "normal" }}>{DateTime1(`${instancelist.start_date}`)}</span>
                                </Typography>
                              </TableCell>
                              {instancelist.start_time === "" ||
                                instancelist.start_time === null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Start Time : <span style={{ fontWeight: "normal" }}>{DateTime3(`${instancelist.start_date}`, `${instancelist.start_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                              <TableCell align="left">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  End Date : <span style={{ fontWeight: "normal" }}>{DateTime2(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                </Typography>
                              </TableCell>

                              {instancelist.stop_time === "" ||
                                instancelist.stop_time === null ? (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    Stop Time : <span style={{ fontWeight: "normal" }}>NA</span>
                                  </Typography>
                                </TableCell>
                              ) : (
                                <TableCell align="left">
                                  <Typography
                                    variant="h6"
                                    fontWeight="fontWeightBold"
                                    style={{ display: "inline-block" }}
                                    gutterBottom
                                  >
                                    End Time : <span style={{ fontWeight: "normal" }}>{DateTime4(`${instancelist.end_date}`, `${instancelist.stop_time}`)}</span>
                                  </Typography>
                                </TableCell>
                              )}
                            </TableRow>
                            <TableRow key="meetingurl">
                              <TableCell align="left" component="th" scope="row">
                                <Typography
                                  variant="h6"
                                  fontWeight="fontWeightBold"
                                  style={{ display: "inline-block" }}
                                  gutterBottom
                                >
                                  Meeting Link:
                                  <a
                                    href={ensureAbsoluteUrl(instancelist.meeting_url)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ textDecoration: 'underline', color: 'blue', marginLeft: '10px' }}
                                  >
                                    {instancelist.meeting_url}
                                  </a>
                                  <CopyToClipboard
                                    text={instancelist.meeting_url}
                                    onCopy={() => setCopied(true)}
                                  >
                                    <IconButton
                                      aria-label="Filter"
                                      color="primary"
                                      onClick={handleClick}
                                      style={{ height: "25px" }}
                                    >
                                      <FileCopyOutlinedIcon style={{ height: "20px" }} />
                                    </IconButton>
                                  </CopyToClipboard>
                                  <Popover
                                    id={id}
                                    open={open1}
                                    anchorEl={anchorEl}
                                    onClose={handleClose1}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "center",
                                    }}
                                    transformOrigin={{
                                      vertical: "top",
                                      horizontal: "center",
                                    }}
                                  >
                                    <Typography style={{ color: "forestgreen" }}>
                                      Copied!.
                                    </Typography>
                                  </Popover>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </CardContent>
                </Card>
              </Box>
              
              <Divider />
              <Box border={0} sx={{ mt: 1 }} paddingBottom={0} paddingTop={0}>
                <Card>
                  <Typography
                    color="textPrimary"
                    variant="h6"
                    gutterBottom
                    style={{ marginLeft: "20px", marginTop: '10px' }}
                  >
                    Instance Details
                    <Divider />
                  </Typography>
                  <TextField
                    fullWidth
                    name={`trainee_name`}
                    id={`trainee_name`}
                    onChange={handleChange}
                    required
                    select
                    SelectProps={{
                      native: true,
                      style: {
                        color: '#000000',
                        height: '30px'
                      },
                    }}
                    autoComplete="name"
                    value={value}
                    sx={{ width: '400px' }}
                    style={{ color: '#ffffff', marginLeft: '20px', marginTop: '10px' }}
                  >
                    <option value="" style={{ color: '#000000' }}>Select the Trainee</option>
                    {instancelist.Instance_info.map((instance_info, i) => (
                      <option key={i} value={i} {...a11yProps(i)} style={{ color: '#000000' }}>
                        {instance_info.name}
                      </option>
                    ))}
                  </TextField>
                  <PerfectScrollbar>
                    <Card>
                      <CardContent>
                        {instancelist.Instance_info.map((instance_info, i) => {
                          return (
                            <React.Fragment key={instance_info.name || i}>
                              <TabPanel value={value} index={i}>
                                <Grid
                                  container
                                  spacing={1}
                                  sx={{ mt: -5, mb: -0.5, ml: 0 }}
                                >
                                  <Grid item xs={12} sx={{ ml: 0 }}>
                                    <Typography
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      Assigned user :
                                    </Typography>
                                    <Typography
                                      fontWeight={500}
                                      sx={{ ml: 1 }}
                                      style={{ display: "inline-block" }}
                                      gutterBottom
                                    >
                                      {instance_info.email}
                                    </Typography>
                                  </Grid>

                                </Grid>
                                <TableContainer component={Paper}>
                                  <Table
                                    size="small"
                                    aria-label="a dense table"
                                  >
                                    <TableHead
                                      style={{ backgroundColor: "#06396c", }}
                                    >
                                      <TableRow sx={{ height: '30px' }}>
                                        <TableCell />
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Name
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff" }}
                                          align="left"
                                        >
                                          Status
                                        </TableCell>
                                        <TableCell
                                          style={{ color: "#ffffff", paddingRight: '10px' }}
                                          align="left"
                                        >
                                          Console Panel
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {instance_info.details.map((details) => (
                                        <React.Fragment key={details.name}>
                                          <TableRow>
                                            <TableCell>
                                              <IconButton
                                                size="small"
                                                onClick={() => handleExpandRow(details.name)}
                                              >
                                                {expandedRow === details.name ? (
                                                  <KeyboardArrowUp />
                                                ) : (
                                                  <KeyboardArrowDown />
                                                )}
                                              </IconButton>
                                            </TableCell>
                                            <TableCell style={{ paddingLeft: '10px' }} align="left">{details.name}</TableCell>
                                            <TableCell style={{ paddingLeft: '5px' }} align="left">
                                              {details.status === "Creating" ? (
                                                <Typography
                                                variant="h6"
                                                sx={{ ml: 2 }}
                                                fontWeight="fontWeightBold"
                                                style={{
                                                  display: "inline-block",
                                                  color: "#2234E8",
                                                }}
                                                gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status ===
                                                "Running" ||
                                                details.status === "running" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#209508",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopped" || details.status === "stopped" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Starting" || details.status === "starting" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stopping" || details.status === "stopping" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Start Initiated" || details.status === "start initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Stop Initiated" || details.status === "stop initiated" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#F3AF05",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Cordoned" || details.status === "cordoned" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#848884",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Create" || details.status === "failed_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Create" || details.status === "failed_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Stop" || details.status === "failed_stop" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Start" || details.status === "failed_start" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Con_Update" || details.status === "failed_con_update" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "Failed_Cordon" || details.status === "failed_cordon" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_remove" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : details.status === "failed_add_con_create" ? (
                                                <Typography
                                                  variant="h6"
                                                  marginLeft={2}
                                                  fontWeight="fontWeightBold"
                                                  style={{
                                                    display: "inline-block",
                                                    color: "#D73206",
                                                  }}
                                                  // marginLeft={1}
                                                  gutterBottom
                                                >
                                                  {details.status}
                                                </Typography>
                                              ) : (
                                                "NA"
                                              )}
                                            </TableCell>
                                            <TableCell align="left" colSpan={3}>
                                              <Tooltip title="Connect" arrow>
                                                <span>
                                                  <Button
                                                    size="small"
                                                    variant="contained"
                                                    target="_blank"
                                                    endIcon={<OpenInNewIcon style={{ height: "15px" }} />}
                                                    href={details.connection_url}
                                                    sx={{
                                                      height: "25px",
                                                      borderRadius: '50px',
                                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                      px: 2,
                                                    }}
                                                    disabled={details.status !== "running" && details.status !== "Running"}
                                                  >
                                                    Connect
                                                  </Button>
                                                </span>
                                              </Tooltip>
                                            </TableCell>
                                          </TableRow>
                                          <TableRow>
                                            <TableCell
                                              style={{ paddingBottom: 0, paddingTop: 0 }}
                                              colSpan={4}
                                            >
                                              <Collapse
                                                in={expandedRow === details.name}
                                                timeout="auto"
                                                unmountOnExit
                                              >
                                                <Box sx={{ p: 1 }}>
                                                  {/* Content to display when row is expanded - Responsive Card Grid */}
                                                  <Grid container spacing={0.5}>
                                                    {/* Row 1 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '140px' }}>
                                                          Instance Public IP:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">
                                                            {details.public_ip_address || 'NA'}
                                                          </Typography>
                                                          {details.public_ip_address && (
                                                            <CopyToClipboard text={details.public_ip_address} onCopy={() => setCopied(true)}>
                                                              <IconButton size="small" color="primary" onClick={handleClick}>
                                                                <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                              </IconButton>
                                                            </CopyToClipboard>
                                                          )}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Instance Username:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">{details.instance_username}</Typography>
                                                          <CopyToClipboard text={details.instance_username} onCopy={() => setCopied(true)}>
                                                            <IconButton size="small" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Instance Password:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          {showInstancePassword ? (
                                                            <Typography variant="body2">{details.instance_password}</Typography>
                                                          ) : (
                                                            <Typography variant="body2">******</Typography>
                                                          )}
                                                          <IconButton size="small" color="primary" onClick={handleInstancePasswordIconClick}>
                                                            {showInstancePassword ? <VisibilityOffIcon style={{ fontSize: "18px" }} /> : <VisibilityIcon style={{ fontSize: "18px" }} />}
                                                          </IconButton>
                                                          <CopyToClipboard text={details.instance_password} onCopy={() => setCopied(true)}>
                                                            <IconButton size="small" color="primary" onClick={handleClick}>
                                                              <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                            </IconButton>
                                                          </CopyToClipboard>
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Popover for Copy confirmation */}
                                                    <Popover
                                                      id={id}
                                                      open={open1}
                                                      anchorEl={anchorEl}
                                                      onClose={handleClose1}
                                                      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                                                      transformOrigin={{ vertical: "top", horizontal: "center" }}
                                                    >
                                                      <Typography style={{ color: "forestgreen", p: 1 }}>Copied!</Typography>
                                                    </Popover>

                                                    {/* Row 2 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '140px' }}>
                                                          Instance Private IP:
                                                        </Typography>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                          <Typography variant="body2">{details.private_ip_address || 'NA'}</Typography>
                                                          {details.private_ip_address && (
                                                            <CopyToClipboard text={details.private_ip_address} onCopy={() => setCopied(true)}>
                                                              <IconButton size="small" color="primary" onClick={handleClick}>
                                                                <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                              </IconButton>
                                                            </CopyToClipboard>
                                                          )}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                          OS Type:
                                                        </Typography>
                                                        <Typography variant="body2">{details.ostype}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          OS Version:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.ostype === 'windows' ? details.windows_type : details.linux_type}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Row 3 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          Open Ports:
                                                        </Typography>
                                                        <Typography variant="body2">{details.port}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                          Storage:
                                                        </Typography>
                                                        <Typography variant="body2">{details.instance_storage}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '120px' }}>
                                                          Instance Type:
                                                        </Typography>
                                                        <Typography variant="body2">{details.instance_type}</Typography>
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Row 4 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '110px' }}>
                                                          Instance CPU:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.instance_type === 'nano' ? '1 vCPUs' :
                                                            details.instance_type === 'micro' ? '1 vCPUs' :
                                                              details.instance_type === 'small' ? '2 vCPUs' :
                                                                details.instance_type === 'medium' ? '2 vCPUs' :
                                                                  details.instance_type === 'large' ? '2 vCPUs' :
                                                                    details.instance_type === 'xlarge' ? '4 vCPUs' :
                                                                      details.instance_type === '2xlarge' ? '8 vCPUs' : 'NA'}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '120px' }}>
                                                          Instance Memory:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.instance_type === 'nano' ? '1 GiB' :
                                                            details.instance_type === 'micro' ? '2 GiB' :
                                                              details.instance_type === 'small' ? '2 GiB' :
                                                                details.instance_type === 'medium' ? '4 GiB' :
                                                                  details.instance_type === 'large' ? '8 GiB' :
                                                                    details.instance_type === 'xlarge' ? '16 GiB' :
                                                                      details.instance_type === '2xlarge' ? '32 GiB' : 'NA'}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '120px' }}>
                                                          Usage Report:
                                                        </Typography>
                                                        <ActiveLog
                                                          name={details.name}
                                                          index_name={details.tag}
                                                          analytics_panel_id={details.analytics_panel_id}
                                                        />
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Row 5 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          Application:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.apps === "notapply" ? 'NA' :
                                                            details.apps.map((number) => <div key={number}>{number}</div>)}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                          Tools:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.tools === "notapply" ? 'NA' : details.tools}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '90px' }}>
                                                          Language:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.programming === "notapply" ? 'NA' :
                                                            details.programming.map((number) => <div key={number}>{number}</div>)}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>

                                                    {/* Row 6 */}
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          System Tool:
                                                        </Typography>
                                                        <Typography variant="body2">
                                                          {details.system_tools === "notapply" ? 'NA' :
                                                            details.system_tools.map((number) => <div key={number}>{number}</div>)}
                                                        </Typography>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '130px' }}>
                                                          Manage Instance:
                                                        </Typography>
                                                        <Box>
                                                          {details.status === "stopped" ? (
                                                            <IndividualStartLab tag={details.tag} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`} startTime={`${instancelist.start_time}`} depends_on={`${instancelist.depends_on}`} manage_labs={instancelist.manage_labs} startcron={instancelist.startcron_expression} startcron1={instancelist.startcron_expression2} repeat_frequency={instancelist.repeat_frequency} on_days={`${instancelist.on_days}`} labType={"wise"}/>
                                                          ) : details.status === "running" ? (
                                                            <IndividualStopLab tag={details.tag} endDate={`${instancelist.end_date}`} endTime={`${instancelist.stop_time}`} startDate={`${instancelist.start_date}`} startTime={`${instancelist.start_time}`} depends_on={`${instancelist.depends_on}`} labType={"wise"}/>
                                                          ) : details.status === "stopping" ? (
                                                            <Tooltip title="stopping" arrow>
                                                              <Button
                                                                sx={{
                                                                  width: { xs: '26px', sm: '30px' },
                                                                  height: { xs: '26px', sm: '30px' },
                                                                  minWidth: 'auto',
                                                                  borderRadius: '50px',
                                                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                  p: 0,
                                                                }}
                                                                variant="outlined"
                                                                color="primary"
                                                                disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                                                                aria-label="stopping"
                                                              >
                                                                <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                                                              </Button>
                                                            </Tooltip>
                                                          ) : details.status === "starting" ? (
                                                            <Tooltip title="Starting" arrow>
                                                            <Button
                                                              sx={{
                                                                width: '120px',
                                                                height: '28px',
                                                                borderRadius: '50px',
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                fontSize: '0.75rem', 
                                                                borderRadius: '50px',
                                                                p: 0,
                                                              }}
                                                              variant="outlined"
                                                              color="primary"
                                                              startIcon={<PlayArrowTwoToneIcon />}
                                                              disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                                                            >
                                                              Starting
                                                              </Button>
                                                            </Tooltip>
                                                          ) : details.status === "stop initiated" ? (
                                                            <Tooltip title="Stop Initiated" arrow>
                                                              <Button
                                                                sx={{
                                                                  width: { xs: '26px', sm: '30px' },
                                                                  height: { xs: '26px', sm: '30px' },
                                                                  minWidth: 'auto',
                                                                  borderRadius: '50px',
                                                                  boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                  borderRadius: '50px',
                                                                  p: 0,
                                                                }}
                                                                variant="outlined"
                                                                color="primary"
                                                                disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                                                                aria-label="Stop Initiated"
                                                              >
                                                                <StopTwoToneIcon sx={{ fontSize: { xs: '1rem', sm: '1.1rem' } }} />
                                                              </Button>
                                                            </Tooltip>
                                                          ) : details.status === "start initiated" ? (
                                                            <div>
                                                              <Tooltip title="Start Initiated" arrow>
                                                                <Button
                                                                  sx={{
                                                                    width: '140px',
                                                                    height: '28px',
                                                                    borderRadius: '50px',
                                                                    // boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                    fontSize: '0.75rem',
                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                                                    borderRadius: '50px',
                                                                    p: 0,
                                                                  }}
                                                                  variant="outlined"
                                                                  color="primary"
                                                                  startIcon={<PlayArrowTwoToneIcon />}
                                                                  disabled={timeDiff(`${instancelist.end_date}`, `${instancelist.stop_time}`)}
                                                                >
                                                                  Start Initiated
                                                                </Button>
                                                              </Tooltip>
                                                            </div>
                                                          ) : null}
                                                        </Box>
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} md={4}>
                                                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                                        <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '100px' }}>
                                                          Activity Log:
                                                        </Typography>
                                                        <Log LabID={instancelist.id} InstanceID={details.name} />
                                                      </Box>
                                                    </Grid>
                                                    <Grid item xs={12}><Divider sx={{ my: 0 }} /></Grid>
                                                    {/* App Credentials Section */}
                                                    {details.app_credential && details.app_credential.length > 0 && (
                                                      <Grid item xs={12}>
                                                        <Typography variant="subtitle2" fontWeight="bold" color="text.primary" sx={{ mb: 1 }}>
                                                          Application Credentials:
                                                        </Typography>
                                                      </Grid>
                                                    )}
                                                    {details.app_credential && details.app_credential.map((cred, index) => (
                                                      <React.Fragment key={index}>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                          <Box sx={{ mb: 2 }}>
                                                            <Typography variant="body2" fontWeight="bold" color="text.primary">
                                                              {cred.app || 'NA'}
                                                            </Typography>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                                                              <Typography variant="body2" color="text.primary">URL: {cred.url || 'NA'}</Typography>
                                                              {cred.url && (
                                                                <CopyToClipboard text={cred.url} onCopy={() => setCopied(true)}>
                                                                  <IconButton size="small" color="primary" onClick={handleClick}>
                                                                    <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                                  </IconButton>
                                                                </CopyToClipboard>
                                                              )}
                                                            </Box>
                                                          </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                          <Box sx={{ mb: 2 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                              <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                                Username:
                                                              </Typography>
                                                              <Typography variant="body2">{cred.username || 'NA'}</Typography>
                                                              {cred.username && (
                                                                <CopyToClipboard text={cred.username} onCopy={() => setCopied(true)}>
                                                                  <IconButton size="small" color="primary" onClick={handleClick}>
                                                                    <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                                  </IconButton>
                                                                </CopyToClipboard>
                                                              )}
                                                            </Box>
                                                          </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4}>
                                                          <Box sx={{ mb: 2 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                              <Typography variant="body2" fontWeight="bold" color="text.primary" sx={{ minWidth: '80px' }}>
                                                                Password:
                                                              </Typography>
                                                              {showAppPasswords ? (
                                                                <Typography variant="body2">{cred.password}</Typography>
                                                              ) : (
                                                                <Typography variant="body2">******</Typography>
                                                              )}
                                                              <IconButton size="small" color="primary" onClick={handleAppPasswordIconClick}>
                                                                {showAppPasswords ? <VisibilityOffIcon style={{ fontSize: "18px" }} /> : <VisibilityIcon style={{ fontSize: "18px" }} />}
                                                              </IconButton>
                                                              <CopyToClipboard text={cred.password} onCopy={() => setCopied(true)}>
                                                                <IconButton size="small" color="primary" onClick={handleClick}>
                                                                  <FileCopyOutlinedIcon style={{ fontSize: "18px" }} />
                                                                </IconButton>
                                                              </CopyToClipboard>
                                                            </Box>
                                                          </Box>
                                                        </Grid>
                                                      </React.Fragment>
                                                    ))}
                                                  </Grid>
                                                </Box>
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </TabPanel>
                            </React.Fragment>
                          );
                        })}
                      </CardContent>
                    </Card>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </Container>
          </Box>
        </React.Fragment>
      ))}
    </>
  );
};

export default Detail;
